var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"building"}},[_c('Nav',{attrs:{"type":"transparent"}}),_vm._v(" 建设中，敬请期待～ ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }